"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orvieto": {
    "6c689cad": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "skipSearch": false
    }],
    "sant-egidio": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d026076": [{
      "hkey": "6a715f84",
      "slug": "sugano",
      "name": "Sugano",
      "primary": true,
      "skipSearch": false
    }],
    "sugano-canonica": [{
      "hkey": "6a715f84",
      "slug": "sugano",
      "name": "Sugano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f72cec28": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "skipSearch": false
    }],
    "891fcbd2": [{
      "hkey": "40c88e01",
      "slug": "bardano-fontanelle",
      "name": "Bardano-Fontanelle",
      "primary": true,
      "skipSearch": false
    }],
    "bardano": [{
      "hkey": "40c88e01",
      "slug": "bardano-fontanelle",
      "name": "Bardano-Fontanelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9af426c8": [{
      "hkey": "517e9bdd",
      "slug": "rocca-ripesena",
      "name": "Rocca Ripesena",
      "primary": true,
      "skipSearch": false
    }],
    "roccaripesena": [{
      "hkey": "517e9bdd",
      "slug": "rocca-ripesena",
      "name": "Rocca Ripesena",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f36986c1": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44e5f991": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "skipSearch": false
    }],
    "san-quirico": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "titignano": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec929dd3": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "skipSearch": false
    }],
    "tordimonte": [{
      "hkey": "b3b501d9",
      "slug": "orvieto",
      "name": "Orvieto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;